// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["VisibleForSalePropertyAgent"]);
}

function unwrap_fragment_conversationContext_AvailableConversationContext_context(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ForSalePropertyV5",
    "RentalPropertyV5"
  ]);
}

function unwrap_fragment_conversationContext(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AvailableConversationContext"]);
}

let fragmentConverter = {"__root":{"conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2":{"u":"fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2"},"conversationContext_AvailableConversationContext_context":{"u":"fragment_conversationContext_AvailableConversationContext_context"},"conversationContext":{"u":"fragment_conversationContext"}}};

let fragmentConverterMap = {
  fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2: unwrap_fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2,
  fragment_conversationContext_AvailableConversationContext_context: unwrap_fragment_conversationContext_AvailableConversationContext_context,
  fragment_conversationContext: unwrap_fragment_conversationContext
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Agent",
    "kind": "LinkedField",
    "name": "agent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageSelectedConversationAnonymousControl_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anonymous",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "conversationContext",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "context",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "agentV2",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v1/*: any*/),
                          "type": "VisibleForSalePropertyAgent",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "ForSalePropertyV5",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v1/*: any*/),
                  "type": "RentalPropertyV5",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "AvailableConversationContext",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ConversationV5",
  "abstractKey": null
};
})());

let wrap_fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2 = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationContext_AvailableConversationContext_context = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_conversationContext = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2 = unwrap_fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2;
exports.wrap_fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2 = wrap_fragment_conversationContext_AvailableConversationContext_context_ForSalePropertyV5_agentV2;
exports.unwrap_fragment_conversationContext_AvailableConversationContext_context = unwrap_fragment_conversationContext_AvailableConversationContext_context;
exports.wrap_fragment_conversationContext_AvailableConversationContext_context = wrap_fragment_conversationContext_AvailableConversationContext_context;
exports.unwrap_fragment_conversationContext = unwrap_fragment_conversationContext;
exports.wrap_fragment_conversationContext = wrap_fragment_conversationContext;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
